// extracted by mini-css-extract-plugin
module.exports = {"container":"X0t7iMW_Lcrs75bPFBuBL"};